import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import MaxSessionEventCount from './MaxSessionEventCount';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  failed: state.trackerSettings.global.failed,
});

export default withTranslation(['administration'])(connect(mapStateToProps, null)(MaxSessionEventCount));
